export const TRACKVISION_DEVICE_TYPES = ['bsj', 'vss-howen', 'jc']

export function isTrackvisionDeviceType(deviceType) {
  return TRACKVISION_DEVICE_TYPES.includes(deviceType)
}

export function isTrackvisionDevice(deviceType) {
  return isTrackvisionDeviceType(deviceType)
}

// get the device code from the alert
export function getDeviceCode(alert) {
  let deviceCode = null
  if (alert?.vehicle?.children?.length > 0) {
    deviceCode = alert.vehicle.children[0]?.device?.deviceCode ?? alert.vehicle.device?.deviceCode
  } else if (alert?.vehicle?.device) {
    deviceCode = alert.vehicle.device.deviceCode
  }
  return deviceCode
}
